import { useParams } from "@tanstack/react-router";
import { ReviewCycleDetail } from "@/components/reviews/ReviewCycleDetail";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { useSetOrigin } from "@/components/shared/origin-context";
import { PageHeader } from "@/components/shared/page-header";
import { useReviewCycle } from "@/hooks/use-review-cycles";

/** One review round: who it covers, who it can't, and generating it. */
export function ReviewRoundDetailPage() {
  const { cycleId } = useParams({ from: "/dashboard/reviews/rounds/$cycleId" });
  const { data } = useReviewCycle(cycleId);

  // So a person's record says "← Back to 2026 mid-year" rather than the
  // generic route label.
  useSetOrigin(data?.name);

  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: data?.name ?? "Round" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title={data?.name ?? "Review round"}
        description={data?.description ?? "The period being reviewed, and everyone it covers."}
      />
      <ReviewCycleDetail cycleId={cycleId} />
    </div>
  );
}
